import BaseShippingController from "./base_shipping_controller";

const RADIX = 10;
const NEW_PAYMENT_METHOD_VAL = 'new_payment';
const NEW_PAYMENT_METHOD_INT = -1;
const SEL_SHIPPING_SVC_RBTN = 'shippingServiceRadioBtn';
const SEL_INSURANCE_CHECKBOX = 'insuranceCheckbox';
const SEL_SIGNATURE_CHECKBOX = 'signatureCheckbox';
const SEL_PAYMENT_METHOD_RBTN = 'paymentMethodRadioBtn';
const SEL_LOADING_MODAL = '#shipping-change-section';
const TARGET_INSURANCE_DISPLAY_PRICE = 'insuranceDisplayPrice';
const TARGET_SIGNATURE_DISPLAY_PRICE = 'signatureDisplayPrice';
const TARGET_SUMMARY_SHIPPING_FEE = 'summaryShippingFee';
const TARGET_SUMMARY_GEAR_SUBTOTAL = 'summaryGearSubtotal';
const TARGET_SUMMARY_ADDITIONAL_COSTS = 'summaryAdditionalCosts';
const TARGET_SUMMARY_ROUNDUP_SUBTOTAL = 'summaryRoundupSubtotal';
const TARGET_SUMMARY_UPSELL_SUBTOTAL = 'summaryUpsellSubtotal';
const TARGET_SUMMARY_FINAL_TOTAL = 'summaryFinalTotal';
const TARGET_TAX_DESCRIPTION = 'summaryTaxDescription';
const TARGET_DISCOUNT = 'summaryDiscount';
const TARGET_TAX_TOTAL = 'summaryTaxTotal';
const IN_CENTS_I = 100;
const IN_CENTS_F = 100.0;

function _serviceCodeToValue(serviceCode) {
  const _map = {
    'ups_ground': 'ups',
    'fedex_home_delivery': 'fedex',
    'free_shipping': 'free_shipping'
  };
  return _map[serviceCode] || serviceCode;
}

function _valueToServiceCode(value) {
  const _map = {
    'ups': 'ups_ground',
    'fedex': 'fedex_home_delivery',
    'free_shipping': 'free_shipping'
  };
  return _map[value] || value;
}

export default class extends BaseShippingController {
  static values = {
    url: String,
    ratesUrl: String
  }

  async connect() {
    // Fetch shipping rates once on page load
    const fetchUrl = this.buildFetchUrl(this.ratesUrlValue);
    this.showLoadingModal(SEL_LOADING_MODAL);

    try {
      const data = await this.fetchJson(fetchUrl);
      console.log("Shipping Rates from Server:", data);

      if (!data || !data.rates) {
        this.hideLoadingModal(SEL_LOADING_MODAL);
        return;
      }

      // Store rates in memory (never re-fetch)
      this.rates = data.rates;

      // Update shipping card display prices
      this._updateShippingCardDisplayPrices(this.rates);

      // Get initial summary calculation from backend
      await this.updateSummary();

      this.hideLoadingModal(SEL_LOADING_MODAL);
    } catch (error) {
      console.error("Error fetching shipping rates:", error);
      this.hideLoadingModal(SEL_LOADING_MODAL);
    }
  }

  async updateSummary() {
    const shipping_spec = {
      insurance: this.getInsuranceChecked(),
      signature: this.getSignatureChecked(),
      shipping_service: this.getSelectedService(),
      payment_method_id: this.getSelectedPaymentMethod()
    };

    // Convert rates object to array format expected by backend
    const ratesArray = Object.values(this.rates);

    const payload = {
      shipping_spec: shipping_spec,
      rates: ratesArray,
      sbid: this.getBasketId()
    };

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const summary = await response.json();
      console.log("Summary from Server:", summary);
      this.updateDisplay(summary);
    } catch (error) {
      console.error("Error updating summary:", error);
    }
  }

  getInsuranceChecked() {
    return $('#shipping_request_insurance').is(':checked');
  }

  getSignatureChecked() {
    return $('#shipping_request_signature').is(':checked');
  }

  getSelectedService() {
    return $(`[data-shipping-target="${SEL_SHIPPING_SVC_RBTN}"]:checked`).val();
  }

  getSelectedPaymentMethod() {
    const val = $(`[data-shipping-target="${SEL_PAYMENT_METHOD_RBTN}"]:checked`).val();
    return val === NEW_PAYMENT_METHOD_VAL ? NEW_PAYMENT_METHOD_INT : parseInt(val, RADIX);
  }

  getBasketId() {
    return $('input[name="sbid"]').val();
  }

  updateDisplay(summary) {
    // Update insurance and signature display
    const insurancePriceElement = $(`[data-shipping-target="${TARGET_INSURANCE_DISPLAY_PRICE}"]`);
    insurancePriceElement.text(summary.insurance.displayPrice);
    this.updatePriceDisplay(insurancePriceElement, summary.insurance.displayPrice);

    const signaturePriceElement = $(`[data-shipping-target="${TARGET_SIGNATURE_DISPLAY_PRICE}"]`);
    signaturePriceElement.text(summary.signature.displayPrice);
    this.updatePriceDisplay(signaturePriceElement, summary.signature.displayPrice);

    // Update summary totals
    $(`[data-shipping-target="${TARGET_SUMMARY_SHIPPING_FEE}"]`).text(summary.summary.shippingFeeDisplayPrice);
    $(`[data-shipping-target="${TARGET_SUMMARY_GEAR_SUBTOTAL}"]`).text(summary.summary.gearSubtotalDisplayPrice || '$0.00');
    $(`[data-shipping-target="${TARGET_SUMMARY_ADDITIONAL_COSTS}"]`).text(summary.summary.additionalCostsDisplayPrice);
    $(`[data-shipping-target="${TARGET_SUMMARY_ROUNDUP_SUBTOTAL}"]`).text(summary.summary.roundupSubtotalDisplayPrice);
    $(`[data-shipping-target="${TARGET_SUMMARY_UPSELL_SUBTOTAL}"]`).text(summary.summary.upsellSubtotalDisplayPrice || '$0.00');
    $(`[data-shipping-target="${TARGET_SUMMARY_FINAL_TOTAL}"]`).text(summary.summary.finalTotalDisplayPrice);
    $(`[data-shipping-target="${TARGET_DISCOUNT}"]`).text('-' + summary.summary.promotionalCredits);

    // Update tax display
    if (summary.summary.TaxAmount === 0) {
      const taxElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_TOTAL}"]`);
      const descriptionElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_DESCRIPTION}"]`);
      if (taxElement) taxElement.style.display = "none";
      if (descriptionElement) descriptionElement.style.display = "none";
    } else {
      const taxElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_TOTAL}"]`);
      const descriptionElement = this.element.querySelector(`[data-shipping-target="${TARGET_TAX_DESCRIPTION}"]`);
      if (taxElement && descriptionElement) {
        taxElement.style.display = "";
        descriptionElement.style.display = "";
        $(`[data-shipping-target="${TARGET_TAX_DESCRIPTION}"]`).text(summary.summary.TaxDescription);
        $(`[data-shipping-target="${TARGET_TAX_TOTAL}"]`).text(summary.summary.stateTaxDisplayPrice);
      }
    }

    // Update hidden fields for form submission (backend calculated these)
    $('#shipping_request_charged_shipping_cost').val(summary.summary.shippingService === 'local_pickup' ? 0 :
      parseFloat(summary.summary.shippingFeeDisplayPrice.replace(/[^0-9.-]+/g,"")));
    $('#shipping_request_charged_insurance_cost').val(summary.insurance.priceCents / IN_CENTS_F);
    $('#shipping_request_charged_signature_cost').val(summary.signature.priceCents / IN_CENTS_F);

    // Update service highlighting
    this._updateShippingPriceClasses(summary.summary.shippingService);
  }

  updatePriceDisplay(element, price) {
    if (price === '$0.00') {
      element.removeClass("text-gray-900").addClass("text-gray-500");
    } else {
      element.removeClass("text-gray-500").addClass("text-gray-900");
    }
  }

  shippingServiceChanged(event) {
    this.updateSummary();
  }

  insuranceSwitchChanged(event) {
    this.updateSummary();
  }

  signatureServiceChanged(event) {
    this.updateSummary();
  }

  paymentMethodChanged(event) {
    $('.payment-source-selected').removeClass('payment-source-selected border border-yellow-500');
    event.target.closest('label').className += ' payment-source-selected border border-yellow-500';
    this.updateSummary();
  }

  _updateShippingPriceClasses(shippingService) {
    const targets = {
      ups: '[data-shipping-target="upsDisplayPrice"]',
      fedex: '[data-shipping-target="fedexDisplayPrice"]',
      localPickup: '[data-shipping-target="localPickupDisplayPrice"]',
      freeShipping: '[data-shipping-target="freeShippingDisplayPrice"]'
    };

    // Reset
    $(targets.ups).removeClass("font-medium text-gray-900").addClass("text-gray-500");
    $(targets.fedex).removeClass("font-medium text-gray-900").addClass("text-gray-500");
    $(targets.localPickup).removeClass("font-medium text-gray-900").addClass("text-gray-500");
    $(targets.freeShipping).removeClass("font-medium text-gray-900").addClass("text-gray-500");

    switch (shippingService) {
      case 'ups':
        $(targets.ups).addClass("font-medium text-gray-900");
        break;
      case 'fedex':
        $(targets.fedex).addClass("font-medium text-gray-900");
        break;
      case 'local_pickup':
        $(targets.localPickup).addClass("font-medium text-gray-900");
        break;
      case 'free_shipping':
        $(targets.freeShipping).addClass("font-medium text-gray-900");
        break;
      default:
        break;
    }
  }

  _updateShippingCardDisplayPrices(newRates) {
    $.each(newRates, (serviceCode, rate) => {
      const frontEndSvcId = _serviceCodeToValue(serviceCode);
      $(`.${frontEndSvcId}-shipping-cost`).text(rate.displayCost);
      $(`.${frontEndSvcId}-shipping-cost`).attr({
        'data-shipment-cost-cents': Math.round(rate.shipmentCost * IN_CENTS_I),
        'data-other-cost-cents': Math.round(rate.otherCost * IN_CENTS_I)
      });
    });
  }
}
